// プラグイン
import "@/javascripts/config/initializers/effects.js";
// wordrabbit コンポーネント
import { stimulus } from "../javascripts/controllers/effects.js";
stimulus();
